export function openGalleryLg(parent, gallery) {
	parent.querySelector(".open-gallery").addEventListener("click", function () {
		gallery.openGallery(0);
	});
}
